import React, { useEffect } from 'react';
import AdminWrapper from './v2/Nav/Admin/AdminWrapper';
import * as analytics from '../utils/analytics';

const NotFound = () => {
  // Equivalent to componentDidMount and componentWillUnmount
  useEffect(() => {
    if (window.location.pathname.startsWith('/learning')) {
      // This scenario should not occur, but if it does, it means
      // that we did a fake navigation when we meant to load
      // one of the new learning routes.
      window.location.reload();
      return () => {};
    } else {
      analytics.pageStart('Page Not Found');

      // Cleanup function equivalent to componentWillUnmount
      return () => {
        analytics.pageEnd();
      };
    }
  }, []);

  return <AdminWrapper hideStaffNav>404 Not Found.</AdminWrapper>;
};

export default NotFound;
